import script from "./MatchinPayGenerateQR.vue?vue&type=script&setup=true&lang=js"
export * from "./MatchinPayGenerateQR.vue?vue&type=script&setup=true&lang=js"

import "./MatchinPayGenerateQR.vue?vue&type=style&index=0&id=8296e35a&lang=css"

const __exports__ = script;

export default __exports__